import { useEffect, useState } from 'react';
import CustomCheckbox from '../components/filters/CustomCheckbox';
import GroupToggle from '../components/filters/GroupToggle';
import Calendar from '../components/filters/Calendar';
import ListCombo from '../components/filters/ListCombo';
import ListFiltersCombo from '../components/filters/ListFiltersCombo';
import { getDefaultValue, updateStorage } from '../services/storageManager';
import '../css/LocalFilters.css';

const DESTINATION_FILTERS = {
    commune: {
        comboName: 'area_small',
        comboLabel: 'Villes',
        placeholder: 'Sélectionnez une ville...'
    },
    epci: {
        comboName: 'area_medium',
        comboLabel: 'Territoires',
        placeholder: 'Sélectionnez un territoire...'
    }
};

const DESTINATION_OPTIONS = [
    { value: 'commune', label: 'Ville' },
    { value: 'epci', label: 'Territoires' }
];

const getDestinationType = (value) => (
    DESTINATION_FILTERS[value] ? value : 'commune'
);

const getInactiveDestinationName = (destinationType) => (
    destinationType === 'commune' ? 'area_medium' : 'area_small'
);

const FvtFilters = ({ query, app }) => {
    const filterStorageKey = (query) ? query : 'fvt';
    const comboApplication = app || 'fvt';
    const category = 'filters';
    const [destinationType, setDestinationType] = useState(() => (
        getDestinationType(getDefaultValue(filterStorageKey, category, 'decselector'))
    ));
    const destinationFilter = DESTINATION_FILTERS[destinationType];

    useEffect(() => {
        const storedDestinationType = getDestinationType(getDefaultValue(filterStorageKey, category, 'decselector'));
        setDestinationType(storedDestinationType);
        updateStorage(filterStorageKey, category, 'decselector', storedDestinationType);
        updateStorage(filterStorageKey, category, getInactiveDestinationName(storedDestinationType), []);
    }, [filterStorageKey, category]);

    const handleDestinationTypeChange = (newDestinationType) => {
        setDestinationType(newDestinationType);
        updateStorage(
            filterStorageKey,
            category,
            getInactiveDestinationName(newDestinationType),
            []
        );
    };

    const jour = [
        { value: 1, label: 'Lundi' },
        { value: 2, label: 'Mardi' },
        { value: 3, label: 'Mercredi' },
        { value: 4, label: 'Jeudi' },
        { value: 5, label: 'Vendredi' },
        { value: 6, label: 'Samedi' },
        { value: 7, label: 'Dimanche' }
    ];

    const zone = [
        { value: 1, label: 'Zone A' },
        { value: 2, label: 'Zone B' },
        { value: 4, label: 'Zone C' },
        { value: 8, label: 'Zone D' },
    ];

    return (
        <div className="local-filters-widget">
            <section className="local-filters-section">
                <div className="local-filters-section-header">
                    <div>
                        <h3 className="local-filters-section-title">Période</h3>
                        <p className="local-filters-section-description">Définissez les bornes temporelles des flux touristiques.</p>
                    </div>
                </div>
                <div className="local-filters-grid local-filters-grid--two">
                    <div className="local-filter-field">
                        <Calendar
                            application={filterStorageKey}
                            category={category}
                            name="startDate"
                            label="Date de début"
                        />
                    </div>
                    <div className="local-filter-field">
                        <Calendar
                            application={filterStorageKey}
                            category={category}
                            name="endDate"
                            label="Date de fin"
                        />
                    </div>
                </div>
            </section>

            <section className="local-filters-section">
                <div className="local-filters-section-header">
                    <div>
                        <h3 className="local-filters-section-title">Calendrier</h3>
                        <p className="local-filters-section-description">Isolez un jour, une période de vacances ou les jours fériés.</p>
                    </div>
                </div>
                <div className="local-filters-grid local-filters-grid--three">
                    <div className="local-filter-field">
                        <ListCombo application={filterStorageKey} comboApplication={comboApplication} category={category} name="jour" label="Jour de la semaine" multiple={false} source={jour} />
                    </div>
                    <div className="local-filter-field">
                        <ListCombo application={filterStorageKey} comboApplication={comboApplication} category={category} name="zone" label="Vacances scolaires" multiple={true} source={zone} />
                    </div>
                    <div className="local-filter-check">
                        <CustomCheckbox application={filterStorageKey} category={category} name="ferie" label="Jour férié" />
                    </div>
                </div>
            </section>

            <section className="local-filters-section">
                <div className="local-filters-section-header">
                    <div>
                        <h3 className="local-filters-section-title">Destination</h3>
                        <p className="local-filters-section-description">Choisissez un niveau de destination puis les zones à conserver.</p>
                    </div>
                </div>
                <div className="local-filters-grid local-filters-grid--two">
                    <div className="local-filter-field">
                        <div className="local-filter-label">Découpage</div>
                        <GroupToggle
                            application={filterStorageKey}
                            category={category}
                            name="decselector"
                            value={destinationType}
                            options={DESTINATION_OPTIONS}
                            onChange={handleDestinationTypeChange}
                        />
                    </div>
                    <div className="local-filter-field">
                        <ListCombo
                            key={`destination-${destinationType}`}
                            application={filterStorageKey}
                            comboApplication={comboApplication}
                            category={category}
                            name={destinationFilter.comboName}
                            label={destinationFilter.comboLabel}
                            multiple={true}
                            source="group"
                            area={destinationType}
                            placeholder={destinationFilter.placeholder}
                        />
                    </div>
                </div>
            </section>

            <section className="local-filters-section">
                <div className="local-filters-section-header">
                    <div>
                        <h3 className="local-filters-section-title">Origine des flux</h3>
                        <p className="local-filters-section-description">Comparez le périmètre de déplacement et l'origine des visiteurs.</p>
                    </div>
                </div>
                <div className="local-filters-grid local-filters-grid--two">
                    <div className="local-filter-field">
                        <div className="local-filter-label">Périmètre</div>
                        <GroupToggle
                            application={filterStorageKey}
                            category="filters"
                            name="intraextra"
                            options={[
                                { value: 'i', label: 'Intra' },
                                { value: '', label: 'Ensemble' },
                                { value: 'e', label: 'Extra' }
                            ]}
                        />
                    </div>
                    <div className="local-filter-field">
                        <div className="local-filter-label">Origine</div>
                        <GroupToggle
                            application={filterStorageKey}
                            category={category}
                            name="etranger"
                            options={[
                                { value: 'true', label: 'Etrangers' },
                                { value: '', label: 'Ensemble' },
                                { value: 'false', label: 'Français' }
                            ]}
                        />
                    </div>
                </div>
            </section>

            <section className="local-filters-section">
                <div className="local-filters-section-header">
                    <div>
                        <h3 className="local-filters-section-title">Visiteurs</h3>
                        <p className="local-filters-section-description">Sélectionnez les profils de visiteurs à conserver dans l'analyse.</p>
                    </div>
                </div>
                <div className="local-filter-field">
                    <ListFiltersCombo application={filterStorageKey} category={category} name="typeVisiteurs" label="Type de visiteurs" multiple={true} source="type_visiteurs" />
                </div>
            </section>
        </div>
    );
};

export default FvtFilters;
